var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-category-list", style: _vm.menusStyle || {} },
    [
      !_vm.isShowAllCategory && _vm.categoryList.length > 1
        ? _c(
            "div",
            { staticClass: "home-menus-category" },
            [
              _c("tab-bar", {
                ref: "tBar",
                attrs: {
                  tabtitles: _vm.categoryList,
                  className: "category-bar",
                  maxTitleNum: 4,
                  defaultActiveId: _vm.currentId,
                  titleWidth: "58",
                  defaultStyle: _vm.menusStyle,
                },
                on: { changeTab: _vm.changeTab },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.isNeedShowAll &&
                !_vm.isShowAllCategory &&
                _vm.categoryList.length > 1,
              expression:
                "isNeedShowAll && !isShowAllCategory && categoryList.length>1",
            },
          ],
          class: [
            "home-menus-more",
            _vm.isShowAllCategory ? "when-show-all" : "",
          ],
          on: { click: _vm.toggleList },
        },
        [
          _c("img", {
            attrs: { src: require("../../image/home/arrow-down.png") },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowAllCategory,
              expression: "isShowAllCategory",
            },
          ],
          staticClass: "home-menus-category-all",
          on: {
            touchmove: function ($event) {
              $event.preventDefault()
            },
            click: _vm.toggleList,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "category-all-title",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.toggleList.apply(null, arguments)
                },
              },
            },
            [
              _vm._v("\n      全部分类\n      "),
              _c("img", {
                attrs: { src: require("../../image/home/arrow-down.png") },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "category-all-main",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            _vm._l(_vm.categoryList, function (c) {
              return _c(
                "div",
                {
                  key: c.id,
                  class: [
                    "category-item",
                    _vm.currentId === c.id ? "actived-item" : "",
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.changeTabInAll(c.id)
                    },
                  },
                },
                [_vm._v(_vm._s(c.name))]
              )
            }),
            0
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }